module.exports = __webpack_public_path__ + "static/Flash_tattoo-15ffa07106c6ac5ffadfa36c67e35f5b.png";